<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="714" height="432" viewBox="0 0 714 432" fill="none">
        <path
            d="M3.17578 479.175C22.6546 396.241 77.2321 329.767 147.246 303.738C217.26 277.71 301.202 292.682 368.83 343.261C378.679 244.952 419.109 155.253 481.277 93.9193C543.435 32.5676 626.856 0.0202019 713.176 3.41646"
            stroke="#E8DDC9" stroke-width="6.35" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: "ShapeBrandLine"
}
</script>